(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["buddy-mode-switcher"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('buddy-mode-switcher')) {
    customElements.define(
      'buddy-mode-switcher',
      class BuddyModeSwitcher extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-buddy-track]');
          this.cards = Array.from(this.querySelectorAll('[data-buddy-card]'));
          this.panels = Array.from(this.querySelectorAll('[data-buddy-panel]'));
          this.backgrounds = Array.from(this.querySelectorAll('[data-buddy-background]'));
          this.dots = Array.from(this.querySelectorAll('[data-buddy-dot]'));
          this.content = this.querySelector('[data-buddy-content]');
          this.mobileProduct = this.querySelector('[data-mobile-product]');
          this.mobileBuddies = Array.from(this.querySelectorAll('[data-mobile-buddy]'));
          this.mobileLabels = Array.from(this.querySelectorAll('[data-mobile-label]'));
          this.previousButtons = Array.from(this.querySelectorAll('[data-buddy-prev]'));
          this.nextButtons = Array.from(this.querySelectorAll('[data-buddy-next]'));
          this.isAutoplayEnabled = this.dataset.autoplay === 'true';
          this.autoplaySpeed = Number(this.dataset.autoplaySpeed) || 4000;
          this.pauseAfterClick = Number(this.dataset.pauseAfterClick) || 10000;
          this.currentIndex = Math.max(
            0,
            this.cards.findIndex((card) => card.classList.contains('is-active'))
          );
          this.intervalId = null;
          this.resumeTimeoutId = null;
          this.scrollTimeoutId = null;
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.mobileQuery = window.matchMedia('(max-width: 749px)');
          this.hoverQuery = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');

          this.handleCardClick = this.handleCardClick.bind(this);
          this.handleCardHover = this.handleCardHover.bind(this);
          this.handleDotClick = this.handleDotClick.bind(this);
          this.handlePreviousClick = this.handlePreviousClick.bind(this);
          this.handleNextClick = this.handleNextClick.bind(this);
          this.handleKeydown = this.handleKeydown.bind(this);
          this.handleScroll = this.handleScroll.bind(this);
          this.handleResize = this.handleResize.bind(this);
          this.handleBlockSelect = this.handleBlockSelect.bind(this);

          this.cards.forEach((card) => {
            card.addEventListener('click', this.handleCardClick);
            card.addEventListener('mouseenter', this.handleCardHover);
            card.addEventListener('keydown', this.handleKeydown);
          });

          this.dots.forEach((dot) => {
            dot.addEventListener('click', this.handleDotClick);
          });

          this.previousButtons.forEach((button) => {
            button.addEventListener('click', this.handlePreviousClick);
          });

          this.nextButtons.forEach((button) => {
            button.addEventListener('click', this.handleNextClick);
          });

          if (this.track) {
            this.track.addEventListener('scroll', this.handleScroll, { passive: true });
          }

          window.addEventListener('resize', this.handleResize);
          this.addEventListener('shopify:block:select', this.handleBlockSelect);

          this.selectCard(this.currentIndex);
          this.startAutoplay();
        }

        disconnectedCallback() {
          this.stopAutoplay();
          clearTimeout(this.resumeTimeoutId);
          clearTimeout(this.scrollTimeoutId);

          this.cards.forEach((card) => {
            card.removeEventListener('click', this.handleCardClick);
            card.removeEventListener('mouseenter', this.handleCardHover);
            card.removeEventListener('keydown', this.handleKeydown);
          });

          this.dots.forEach((dot) => {
            dot.removeEventListener('click', this.handleDotClick);
          });

          this.previousButtons.forEach((button) => {
            button.removeEventListener('click', this.handlePreviousClick);
          });

          this.nextButtons.forEach((button) => {
            button.removeEventListener('click', this.handleNextClick);
          });

          if (this.track) {
            this.track.removeEventListener('scroll', this.handleScroll);
          }

          window.removeEventListener('resize', this.handleResize);
          this.removeEventListener('shopify:block:select', this.handleBlockSelect);
        }

        handleCardClick(event) {
          this.selectCard(Number(event.currentTarget.dataset.index), { pause: true, center: true });
        }

        handleCardHover(event) {
          if (!this.hoverQuery.matches) {
            return;
          }

          this.selectCard(Number(event.currentTarget.dataset.index), { pause: true });
        }

        handleDotClick(event) {
          this.selectCard(Number(event.currentTarget.dataset.index), { pause: true, center: true });
        }

        handlePreviousClick() {
          this.selectCard((this.currentIndex - 1 + this.cards.length) % this.cards.length, { pause: true });
        }

        handleNextClick() {
          this.selectCard((this.currentIndex + 1) % this.cards.length, { pause: true });
        }

        handleKeydown(event) {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft' && event.key !== 'Home' && event.key !== 'End') {
            return;
          }

          event.preventDefault();

          let nextIndex = this.currentIndex;

          if (event.key === 'ArrowRight') {
            nextIndex = (this.currentIndex + 1) % this.cards.length;
          }

          if (event.key === 'ArrowLeft') {
            nextIndex = (this.currentIndex - 1 + this.cards.length) % this.cards.length;
          }

          if (event.key === 'Home') {
            nextIndex = 0;
          }

          if (event.key === 'End') {
            nextIndex = this.cards.length - 1;
          }

          this.selectCard(nextIndex, { pause: true, center: true, focus: true });
        }

        handleScroll() {
          if (!this.mobileQuery.matches || !this.track) {
            return;
          }

          clearTimeout(this.scrollTimeoutId);
          this.scrollTimeoutId = setTimeout(() => {
            const nextIndex = this.getCenteredCardIndex();

            if (nextIndex !== this.currentIndex) {
              this.selectCard(nextIndex, { pause: true });
            }
          }, 110);
        }

        handleResize() {
          if (this.mobileQuery.matches) {
            this.centerCard(this.currentIndex);
          }
        }

        handleBlockSelect(event) {
          const selectedCard = event.target.closest('[data-buddy-card]');

          if (!selectedCard) {
            return;
          }

          this.selectCard(Number(selectedCard.dataset.index), { pause: true, center: true });
        }

        getCenteredCardIndex() {
          if (!this.track || !this.cards.length) {
            return this.currentIndex;
          }

          const trackRect = this.track.getBoundingClientRect();
          const trackCenter = trackRect.left + trackRect.width / 2;
          let closestIndex = this.currentIndex;
          let closestDistance = Infinity;

          this.cards.forEach((card, index) => {
            const cardRect = card.getBoundingClientRect();
            const cardCenter = cardRect.left + cardRect.width / 2;
            const distance = Math.abs(trackCenter - cardCenter);

            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });

          return closestIndex;
        }

        selectCard(index, options = {}) {
          if (!this.cards.length || index < 0 || index >= this.cards.length) {
            return;
          }

          this.currentIndex = index;

          this.cards.forEach((card, cardIndex) => {
            const isActive = cardIndex === index;
            card.classList.toggle('is-active', isActive);
            card.setAttribute('aria-selected', String(isActive));
            card.setAttribute('tabindex', isActive ? '0' : '-1');
          });

          this.panels.forEach((panel, panelIndex) => {
            const isActive = panelIndex === index;
            panel.classList.toggle('is-active', isActive);
            panel.toggleAttribute('hidden', !isActive);
          });

          this.backgrounds.forEach((background, backgroundIndex) => {
            background.classList.toggle('is-active', backgroundIndex === index);
          });

          this.mobileBuddies.forEach((buddy, buddyIndex) => {
            buddy.classList.toggle('is-active', buddyIndex === index);
          });

          this.mobileLabels.forEach((label, labelIndex) => {
            label.classList.toggle('is-active', labelIndex === index);
          });

          this.dots.forEach((dot) => {
            const isActive = Number(dot.dataset.index) === index;
            dot.classList.toggle('is-active', isActive);
            dot.setAttribute('aria-current', String(isActive));
          });

          if (this.mobileProduct && this.cards[index]) {
            const accentColor = this.cards[index].style.getPropertyValue('--buddy-accent');
            this.mobileProduct.style.setProperty('--mobile-product-accent', accentColor);

            if (this.content) {
              this.content.style.setProperty('--buddy-accent', accentColor);
            }
          }

          if (options.center) {
            this.centerCard(index);
          }

          if (options.focus) {
            this.cards[index].focus();
          }

          if (options.pause) {
            this.pauseAutoplay();
          }
        }

        centerCard(index) {
          if (!this.mobileQuery.matches || !this.cards[index] || !this.track || this.track.offsetParent === null) {
            return;
          }

          this.cards[index].scrollIntoView({
            behavior: this.reducedMotion.matches ? 'auto' : 'smooth',
            block: 'nearest',
            inline: 'center'
          });
        }

        startAutoplay() {
          this.stopAutoplay();

          if (!this.isAutoplayEnabled || this.reducedMotion.matches || this.cards.length <= 1) {
            return;
          }

          this.intervalId = setInterval(() => {
            this.selectCard((this.currentIndex + 1) % this.cards.length, { center: true });
          }, this.autoplaySpeed);
        }

        stopAutoplay() {
          if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
          }
        }

        pauseAutoplay() {
          if (!this.isAutoplayEnabled || this.reducedMotion.matches) {
            return;
          }

          this.stopAutoplay();
          clearTimeout(this.resumeTimeoutId);
          this.resumeTimeoutId = setTimeout(() => this.startAutoplay(), this.pauseAfterClick);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zegbot-hero-2-0"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zegbot-hero-carousel')) {
    customElements.define(
      'zegbot-hero-carousel',
      class ZegbotHeroCarousel extends HTMLElement {
        constructor() {
          super();
          this.currentIndex = 0;
          this.autoplayTimer = null;
          this.contentAnimationTimer = null;
          this.headerUpdateFrame = null;
          this.headerMutationObserver = null;
          this.headerResizeObserver = null;
          this.headerRoot = null;
          this.headerTargets = [];
          this.headerLogos = [];
          this.headerLogoGroups = [];
          this.lastHeaderSignature = '';
          this.touchStartX = 0;
          this.touchStartY = 0;
          this.isHovering = false;
          this.isFocused = false;
          this.isInitialized = false;
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.handlePreviousClick = this.handlePreviousClick.bind(this);
          this.handleNextClick = this.handleNextClick.bind(this);
          this.handleDotClick = this.handleDotClick.bind(this);
          this.handleKeydown = this.handleKeydown.bind(this);
          this.handleMouseEnter = this.handleMouseEnter.bind(this);
          this.handleMouseLeave = this.handleMouseLeave.bind(this);
          this.handleFocusIn = this.handleFocusIn.bind(this);
          this.handleFocusOut = this.handleFocusOut.bind(this);
          this.handleTouchStart = this.handleTouchStart.bind(this);
          this.handleTouchEnd = this.handleTouchEnd.bind(this);
          this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
          this.handleBlockSelect = this.handleBlockSelect.bind(this);
          this.handleReducedMotionChange = this.handleReducedMotionChange.bind(this);
          this.handleHeaderViewportChange = this.handleHeaderViewportChange.bind(this);
        }

        connectedCallback() {
          if (this.isInitialized) {
            return;
          }

          this.isInitialized = true;
          this.slides = Array.from(this.querySelectorAll('[data-zegbot-slide]'));
          this.dots = Array.from(this.querySelectorAll('[data-zegbot-dot]'));
          this.previousButton = this.querySelector('[data-zegbot-previous]');
          this.nextButton = this.querySelector('[data-zegbot-next]');
          this.media = this.querySelector('[data-zegbot-media]');
          this.isAutoplayEnabled = this.dataset.autoplay === 'true';
          this.autoplayInterval = Math.max(Number(this.dataset.autoplayInterval) || 6000, 2000);

          if (this.previousButton) {
            this.previousButton.addEventListener('click', this.handlePreviousClick);
          }

          if (this.nextButton) {
            this.nextButton.addEventListener('click', this.handleNextClick);
          }

          this.dots.forEach((dot) => {
            dot.addEventListener('click', this.handleDotClick);
          });

          this.addEventListener('keydown', this.handleKeydown);
          this.addEventListener('mouseenter', this.handleMouseEnter);
          this.addEventListener('mouseleave', this.handleMouseLeave);
          this.addEventListener('focusin', this.handleFocusIn);
          this.addEventListener('focusout', this.handleFocusOut);
          this.addEventListener('shopify:block:select', this.handleBlockSelect);

          if (this.media) {
            this.media.addEventListener('touchstart', this.handleTouchStart, { passive: true });
            this.media.addEventListener('touchend', this.handleTouchEnd, { passive: true });
          }

          if (this.reducedMotion.addEventListener) {
            this.reducedMotion.addEventListener('change', this.handleReducedMotionChange);
          }

          document.addEventListener('visibilitychange', this.handleVisibilityChange);
          this.initializeHeaderIntegration();
          this.selectSlide(this.currentIndex, false);
          this.startAutoplay();
        }

        disconnectedCallback() {
          this.stopAutoplay();
          window.clearTimeout(this.contentAnimationTimer);

          if (this.previousButton) {
            this.previousButton.removeEventListener('click', this.handlePreviousClick);
          }

          if (this.nextButton) {
            this.nextButton.removeEventListener('click', this.handleNextClick);
          }

          this.dots.forEach((dot) => {
            dot.removeEventListener('click', this.handleDotClick);
          });

          this.removeEventListener('keydown', this.handleKeydown);
          this.removeEventListener('mouseenter', this.handleMouseEnter);
          this.removeEventListener('mouseleave', this.handleMouseLeave);
          this.removeEventListener('focusin', this.handleFocusIn);
          this.removeEventListener('focusout', this.handleFocusOut);
          this.removeEventListener('shopify:block:select', this.handleBlockSelect);

          if (this.media) {
            this.media.removeEventListener('touchstart', this.handleTouchStart);
            this.media.removeEventListener('touchend', this.handleTouchEnd);
          }

          if (this.reducedMotion.removeEventListener) {
            this.reducedMotion.removeEventListener('change', this.handleReducedMotionChange);
          }

          document.removeEventListener('visibilitychange', this.handleVisibilityChange);
          this.cleanupHeaderIntegration();
          this.isInitialized = false;
        }

        handlePreviousClick() {
          this.goToPrevious();
          this.restartAutoplay();
        }

        handleNextClick() {
          this.goToNext();
          this.restartAutoplay();
        }

        handleDotClick(event) {
          this.selectSlide(Number(event.currentTarget.dataset.index));
          this.restartAutoplay();
        }

        handleKeydown(event) {
          const supportedKeys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];

          if (!supportedKeys.includes(event.key) || !this.canSlide()) {
            return;
          }

          event.preventDefault();

          if (event.key === 'ArrowLeft') {
            this.goToPrevious();
          } else if (event.key === 'ArrowRight') {
            this.goToNext();
          } else if (event.key === 'Home') {
            this.selectSlide(0);
          } else if (event.key === 'End') {
            this.selectSlide(this.slides.length - 1);
          }

          this.restartAutoplay();
        }

        handleMouseEnter() {
          this.isHovering = true;
          this.stopAutoplay();
        }

        handleMouseLeave() {
          this.isHovering = false;
          this.startAutoplay();
        }

        handleFocusIn() {
          this.isFocused = true;
          this.stopAutoplay();
        }

        handleFocusOut(event) {
          if (event.relatedTarget && this.contains(event.relatedTarget)) {
            return;
          }

          this.isFocused = false;
          this.startAutoplay();
        }

        handleTouchStart(event) {
          if (!event.changedTouches.length) {
            return;
          }

          this.touchStartX = event.changedTouches[0].clientX;
          this.touchStartY = event.changedTouches[0].clientY;
          this.stopAutoplay();
        }

        handleTouchEnd(event) {
          if (!event.changedTouches.length) {
            return;
          }

          if (this.canSlide()) {
            const touchEndX = event.changedTouches[0].clientX;
            const touchEndY = event.changedTouches[0].clientY;
            const deltaX = touchEndX - this.touchStartX;
            const deltaY = touchEndY - this.touchStartY;

            if (Math.abs(deltaX) > 48 && Math.abs(deltaX) > Math.abs(deltaY)) {
              if (deltaX < 0) {
                this.goToNext();
              } else {
                this.goToPrevious();
              }
            }
          }

          this.restartAutoplay();
        }

        handleVisibilityChange() {
          if (document.hidden) {
            this.stopAutoplay();
            return;
          }

          this.startAutoplay();
        }

        handleReducedMotionChange() {
          if (this.reducedMotion.matches) {
            this.stopAutoplay();
            this.classList.remove('is-content-entering');
            return;
          }

          this.startAutoplay();
        }

        handleBlockSelect(event) {
          const eventTarget = event.target instanceof Element ? event.target : null;
          const selectedSlide = eventTarget ? eventTarget.closest('[data-zegbot-slide]') : null;

          if (!selectedSlide || !this.contains(selectedSlide)) {
            return;
          }

          this.selectSlide(Number(selectedSlide.dataset.index));
          this.stopAutoplay();
        }

        initializeHeaderIntegration() {
          if (this.dataset.isHomepage !== 'true') {
            return;
          }

          const firstHomepageHero = document.querySelector('zegbot-hero-carousel[data-is-homepage="true"]');

          if (firstHomepageHero !== this) {
            return;
          }

          const foundHeader = document.querySelector('.section-header, #shopify-section-header, sticky-header, header.header');

          if (!foundHeader) {
            return;
          }

          this.headerRoot = foundHeader.closest('.shopify-section, .section-header') || foundHeader;
          this.headerTargets = [
            this.headerRoot,
            this.headerRoot.querySelector('sticky-header'),
            this.headerRoot.querySelector('.header-wrapper'),
            this.headerRoot.querySelector('header.header')
          ].filter((target, index, targets) => target && targets.indexOf(target) === index);
          this.headerRoot.dataset.zegbotHeroHeaderRoot = 'true';
          this.headerLogos = Array.from(
            this.headerRoot.querySelectorAll(
              'img.header__heading-logo, .header__heading-link img, [class*="logo"] img, a[href="/"] img'
            )
          );

          this.headerLogos.forEach((logo) => {
            if (!logo.dataset.zegbotOriginalSrc) {
              logo.dataset.zegbotOriginalSrc = logo.getAttribute('src') || '';
              logo.dataset.zegbotOriginalSrcset = logo.getAttribute('srcset') || '';
              logo.dataset.zegbotOriginalSizes = logo.getAttribute('sizes') || '';
            }

            this.restoreLogoAttributes(logo);
          });

          this.prepareNightHeaderLogos();

          window.addEventListener('scroll', this.handleHeaderViewportChange, { passive: true });
          window.addEventListener('resize', this.handleHeaderViewportChange, { passive: true });

          this.headerMutationObserver = new MutationObserver(this.handleHeaderViewportChange);
          this.headerMutationObserver.observe(this.headerRoot, {
            attributes: true,
            attributeFilter: ['open', 'class', 'aria-expanded'],
            childList: true,
            subtree: true
          });

          if ('ResizeObserver' in window) {
            this.headerResizeObserver = new ResizeObserver(this.handleHeaderViewportChange);
            this.headerResizeObserver.observe(this.headerRoot);
          }

          this.updateHeaderState();
        }

        cleanupHeaderIntegration() {
          window.cancelAnimationFrame(this.headerUpdateFrame);
          window.removeEventListener('scroll', this.handleHeaderViewportChange);
          window.removeEventListener('resize', this.handleHeaderViewportChange);

          if (this.headerMutationObserver) {
            this.headerMutationObserver.disconnect();
            this.headerMutationObserver = null;
          }

          if (this.headerResizeObserver) {
            this.headerResizeObserver.disconnect();
            this.headerResizeObserver = null;
          }

          this.restoreHeaderLogo();

          this.headerLogoGroups.forEach((group) => {
            group.originals.forEach((element) => element.classList.remove('zegbot-original-header-logo--hidden'));

            if (group.nightLogo && group.nightLogo.dataset.zegbotNightLogoOwner === this.dataset.sectionId) {
              group.nightLogo.remove();
            }
          });

          this.headerTargets.forEach((target) => {
            if (target.dataset.zegbotHeroOwner === this.dataset.sectionId) {
              delete target.dataset.zegbotHeroOwner;
              delete target.dataset.zegbotHeroHeaderState;
              delete target.dataset.zegbotHeroHeaderTheme;
            }
          });

          if (this.headerRoot && this.headerRoot.dataset.zegbotHeroOwner === undefined) {
            delete this.headerRoot.dataset.zegbotHeroHeaderRoot;
          }

          this.headerTargets = [];
          this.headerLogos = [];
          this.headerLogoGroups = [];
          this.headerRoot = null;
          this.lastHeaderSignature = '';
        }

        handleHeaderViewportChange() {
          if (this.headerUpdateFrame) {
            return;
          }

          this.headerUpdateFrame = window.requestAnimationFrame(() => {
            this.headerUpdateFrame = null;
            this.updateHeaderState();
          });
        }

        isMobileMenuOpen() {
          if (!this.headerRoot || !window.matchMedia('(max-width: 749px)').matches) {
            return false;
          }

          return Boolean(
            this.headerRoot.querySelector(
              'header-drawer details[open], details.menu-drawer-container[open], .menu-drawer-container[open], .menu-opening'
            )
          );
        }

        updateHeaderState() {
          if (!this.headerRoot || !this.isConnected) {
            return;
          }

          const headerHeight = Math.round(this.headerRoot.getBoundingClientRect().height || 0);
          const headerPosition = window.getComputedStyle(this.headerRoot).position;
          const overlapOffset = headerPosition === 'fixed' || headerPosition === 'absolute' ? 0 : -headerHeight;
          const heroRect = this.getBoundingClientRect();
          const menuOpen = this.isMobileMenuOpen();
          const isWithinHero = heroRect.top <= headerHeight && heroRect.bottom > headerHeight;
          const state = isWithinHero && !menuOpen ? 'transparent' : 'solid';
          const theme = state === 'transparent' && this.dataset.activeTheme === 'light' ? 'light' : 'dark';
          const signature = `${state}:${theme}:${headerHeight}`;

          if (headerHeight > 0) {
            this.style.setProperty('--zegbot-header-height-desktop', `${headerHeight}px`);
            this.style.setProperty('--zegbot-header-height-mobile', `${headerHeight}px`);
            this.style.setProperty('--zegbot-header-overlap-offset', `${overlapOffset}px`);
          }

          if (signature === this.lastHeaderSignature) {
            return;
          }

          this.lastHeaderSignature = signature;

          this.headerTargets.forEach((target) => {
            target.dataset.zegbotHeroOwner = this.dataset.sectionId;
            target.dataset.zegbotHeroHeaderState = state;
            target.dataset.zegbotHeroHeaderTheme = theme;
          });

          this.updateHeaderLogo(state, theme);
          document.dispatchEvent(
            new CustomEvent('zegbot:hero-header-change', {
              detail: {
                sectionId: this.dataset.sectionId,
                state,
                theme,
                nightLogo: this.dataset.nightHeaderLogo || ''
              }
            })
          );
        }

        updateHeaderLogo(state, theme) {
          const nightLogo = this.dataset.nightHeaderLogo;
          const useNightLogo = state === 'transparent' && theme === 'light' && nightLogo;

          this.headerLogoGroups.forEach((group) => {
            group.originals.forEach((element) => {
              element.classList.toggle('zegbot-original-header-logo--hidden', Boolean(useNightLogo));
            });

            if (group.nightLogo) {
              group.nightLogo.src = nightLogo || '';
              group.nightLogo.hidden = !useNightLogo;
            }
          });

          if (!useNightLogo) {
            this.restoreHeaderLogo();
          }
        }

        prepareNightHeaderLogos() {
          const nightLogoUrl = this.dataset.nightHeaderLogo;

          if (!nightLogoUrl || !this.headerRoot) {
            return;
          }

          const logoLinks = [
            ...this.headerRoot.querySelectorAll('.header__heading-link, .header__heading a, [class*="logo"] a, a[href="/"]'),
            ...this.headerLogos.map((logo) => logo.closest('a')).filter(Boolean)
          ].filter((link, index, links) => links.indexOf(link) === index && link.querySelector('img, picture, svg'));

          logoLinks.forEach((link) => {
            const originals = Array.from(link.querySelectorAll('picture, img, svg')).filter(
              (element) =>
                !element.classList.contains('zegbot-night-header-logo') &&
                !(element instanceof HTMLImageElement && element.closest('picture'))
            );
            let nightLogo = link.querySelector(`.zegbot-night-header-logo[data-zegbot-night-logo-owner="${this.dataset.sectionId}"]`);

            if (!nightLogo) {
              nightLogo = document.createElement('img');
              nightLogo.className = 'zegbot-night-header-logo';
              nightLogo.dataset.zegbotNightLogoOwner = this.dataset.sectionId;
              nightLogo.alt = '';
              nightLogo.setAttribute('aria-hidden', 'true');
              nightLogo.hidden = true;
              link.appendChild(nightLogo);
            }

            nightLogo.src = nightLogoUrl;
            this.headerLogoGroups.push({ link, originals, nightLogo });
          });
        }

        restoreHeaderLogo() {
          this.headerLogos.forEach((logo) => this.restoreLogoAttributes(logo));
        }

        restoreLogoAttributes(logo) {
          const originalSrc = logo.dataset.zegbotOriginalSrc;
          const originalSrcset = logo.dataset.zegbotOriginalSrcset;
          const originalSizes = logo.dataset.zegbotOriginalSizes;

          if (originalSrc) {
            logo.setAttribute('src', originalSrc);
          }

          if (originalSrcset) {
            logo.setAttribute('srcset', originalSrcset);
          } else {
            logo.removeAttribute('srcset');
          }

          if (originalSizes) {
            logo.setAttribute('sizes', originalSizes);
          } else {
            logo.removeAttribute('sizes');
          }
        }

        canSlide() {
          return this.slides.length > 1;
        }

        goToPrevious() {
          if (!this.canSlide()) {
            return;
          }

          this.selectSlide((this.currentIndex - 1 + this.slides.length) % this.slides.length);
        }

        goToNext() {
          if (!this.canSlide()) {
            return;
          }

          this.selectSlide((this.currentIndex + 1) % this.slides.length);
        }

        selectSlide(index, animateContent = true) {
          if (!this.slides.length || index < 0 || index >= this.slides.length) {
            return;
          }

          this.currentIndex = index;
          const activeSlide = this.slides[index];
          const activeTheme = activeSlide.dataset.textTheme === 'light' ? 'light' : 'dark';
          const activeMobileAspectRatio = Number(activeSlide.dataset.mobileAspectRatio) || 0.8;
          const mobileTextPlacements = ['above_image', 'overlay_upper', 'overlay_lower'];
          const activeMobileTextPlacement = mobileTextPlacements.includes(activeSlide.dataset.mobileTextPlacement)
            ? activeSlide.dataset.mobileTextPlacement
            : 'overlay_upper';
          const activeMobileTextOffset = Math.min(Math.max(Number(activeSlide.dataset.mobileTextVerticalOffset) || 0, 0), 80);

          this.dataset.activeTheme = activeTheme;
          this.dataset.mobileTextPlacement = activeMobileTextPlacement;
          this.style.setProperty('--zegbot-active-mobile-aspect-ratio', String(activeMobileAspectRatio));
          this.style.setProperty('--zegbot-active-mobile-text-offset', `${activeMobileTextOffset}px`);

          this.slides.forEach((slide, slideIndex) => {
            const isActive = slideIndex === index;
            slide.classList.toggle('is-active', isActive);
            slide.setAttribute('aria-hidden', String(!isActive));
          });

          this.dots.forEach((dot, dotIndex) => {
            const isActive = dotIndex === index;
            dot.classList.toggle('is-active', isActive);

            if (isActive) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });

          this.updateHeaderState();

          if (animateContent) {
            this.replayContentAnimation();
          }
        }

        replayContentAnimation() {
          window.clearTimeout(this.contentAnimationTimer);
          this.classList.remove('is-content-entering');

          if (this.reducedMotion.matches) {
            return;
          }

          void this.offsetWidth;
          this.classList.add('is-content-entering');
          this.contentAnimationTimer = window.setTimeout(() => {
            this.classList.remove('is-content-entering');
          }, 850);
        }

        startAutoplay() {
          this.stopAutoplay();

          if (!this.isAutoplayEnabled || !this.canSlide() || this.reducedMotion.matches || this.isHovering || this.isFocused || document.hidden) {
            return;
          }

          this.autoplayTimer = window.setInterval(() => {
            this.goToNext();
          }, this.autoplayInterval);
        }

        stopAutoplay() {
          if (!this.autoplayTimer) {
            return;
          }

          window.clearInterval(this.autoplayTimer);
          this.autoplayTimer = null;
        }

        restartAutoplay() {
          this.stopAutoplay();
          this.startAutoplay();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
